// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3HRGl","savePackageButton":"ClientWallet_savePackageButton__2W2_W"};